import React from "react";
import CountUp from "react-countup";
import {
  Row,
  Col,
  Card,
  CardBody,
} from "reactstrap";

const DashboardWidgets = ({
  channels = [],
  syncDashboard = {},
  roomMappings = [],
  bookingLogs = [],
  restrictions = [],
  inventoryLogs = [],
}) => {
  const widgets = [
    {
      title: "Connected Channels",
      value: channels.filter(
        (x) => x.enabled === true
      ).length,
      icon: "bx bx-link",
      color: "success",
    },

    {
      title: "Room Mappings",
      value: roomMappings.length,
      icon: "bx bx-home",
      color: "primary",
    },

    {
      title: "Total Syncs",
      value:
        syncDashboard?.totalSyncs || 0,
      icon: "bx bx-refresh",
      color: "info",
    },

    {
      title: "Failed Syncs",
      value:
        syncDashboard?.failed || 0,
      icon: "bx bx-error-circle",
      color: "danger",
    },

    {
      title: "Bookings Received",
      value: bookingLogs.length,
      icon: "bx bx-calendar",
      color: "warning",
    },

    {
      title: "Cancelled Bookings",
      value: bookingLogs.filter(
        (x) =>
          x.status?.toUpperCase() ===
          "CANCELLED"
      ).length,
      icon: "bx bx-x-circle",
      color: "danger",
    },

    {
      title: "Restrictions",
      value: restrictions.length,
      icon: "bx bx-lock",
      color: "secondary",
    },

    {
      title: "Inventory Changes",
      value: inventoryLogs.length,
      icon: "bx bx-package",
      color: "dark",
    },
  ];

  return (
    <Row>
      {widgets.map(
        (item, index) => (
          <Col
            xl={3}
            md={6}
            key={index}
          >
            <Card
              className={`card-animate bg-${item.color} text-white`}
            >
              <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <p className="text-white mb-2 fw-medium">
                      {item.title}
                    </p>

                    <h2 className="mb-0 text-white">
                      <CountUp
                        end={item.value}
                        duration={1}
                      />
                    </h2>
                  </div>

                  <div>
                    <i
                      className={`${item.icon} text-white`}
                      style={{
                        fontSize: "36px",
                      }}
                    />
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        )
      )}
    </Row>
  );
};

export default DashboardWidgets;